<script>
  import { apiServer } from "../config.js";
  import { fade } from "svelte/transition";
  import { redirect } from "../pager";
  import Alert from "../components/Alert.svelte";
  import Load from "../components/Load.svelte";
  import AXHR from "../components/js/axhr.js";

  import { session } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });

  let alert = [];
  let shake = "shake";
  let user = "";
  let pass = "";
  let loading = false;
  async function handleSubmit(event) {
    loading = true;
    shake = "";
    var data = JSON.stringify({ email: user, password: pass });
    var config = {
      method: "post",
      url: apiServer + "/accounts/authenticate",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    AXHR(config)
      .then(function (response) {
        let sessionData = {
          api: apiServer,
          token: response.data.jwtToken,
          loggedin: true,
          user: response.data,
          routers: sessions.routers,
          routeractive: sessions.routeractive,
          notifications: { invoice: 0, info: 0 },
        };
        session.update((n) => sessionData);

        localStorage.setItem("t", JSON.stringify(response.data));

        if (sessions.loggedin == true) {
          redirect("/");
        }
      })
      .catch(function (error) {
        if (error.response) {
          loading = false;
          pass = "";
          shake = "shake";
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: error.response.data.message,
              color: "yellow",
            },
          ];
        } else {
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: "It seems we are not well connected ",
              color: "red",
            },
          ];
        }
      })
      .then(function () {
        loading = false;
        // always executed
        if (!sessionStorage["welcome_message"]) {
          alert = [
            ...alert,
            {
              message: "Hello, welcome, have a nice day ...",
              color: "green",
            },
          ];
        }
        sessionStorage["welcome_message"] = false;
      });
  }
</script>

<svelte:head>
  <title>Login To Mikhub</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<main
  transition:fade
  class="flex justify-end max-w-screen-xl px-2 pt-0 mx-auto mb-2 lg:pt-0 md:pt-16"
>
  {#if loading}
    <Load />
  {/if}
  <div class="shake {shake}">
    <div class="w-full mx-auto mt-24 lg:mt-5 md:w-2/4 lg:w-4/12">
      <div class="flex justify-center font-bold">
        <img
          on:click={() => redirect("/")}
          src="./assets/logo/logo.svg"
          width="274"
          height="64"
          alt="logo"
          class="h-16 cursor-pointer"
        />
      </div>
      <h2 class="mb-4 text-center text-gray-700 text-1xl">
        Please <b>Login</b> With Your Account
      </h2>
      <div class="flex flex-wrap items-center w-full mx-auto my-5 lg:my-0 ">
        <div class="w-full mx-auto mb-2">
          <div class="block px-4 py-3 bg-white rounded-lg shadow-md group">
            <ul class="mt-5 list-unstyled multi-steps tablist" />
            <div id="stepcontID1" class="block stepcontID">
              <form
                autocomplete="off"
                class="w-full"
                on:submit|preventDefault={handleSubmit}
              >
                <div class="px-2 pb-2">
                  <div class="w-full mb-2">
                    <a
                      href="/"
                      on:click={() => redirect("/")}
                      class="inline-block px-2 py-1 mb-2 text-sm text-gray-600 border rounded focus:outline-none"
                      >&lt; Back ...</a
                    >
                    <div class="flex items-center">
                      <input
                        name="user"
                        autocomplete="off"
                        bind:value={user}
                        type="text"
                        id="user"
                        placeholder="Username"
                        class="w-full px-3 py-2 text-2xl text-center text-gray-700 border rounded-lg form-input focus:outline-none"
                      />
                    </div>
                  </div>
                  <div class="w-full mb-2">
                    <div class="flex items-center">
                      <input
                        name="pass"
                        autocomplete="off"
                        bind:value={pass}
                        type="Password"
                        id="pass"
                        placeholder="Password"
                        class="w-full px-3 py-2 text-2xl text-center text-gray-700 border rounded-lg form-input focus:outline-none"
                      />
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="w-full px-5 py-2 text-gray-100 bg-gray-700 rounded-lg form-input text-1xl active:bg-gray-500 focus:outline-none"
                  >
                    LOGIN
                  </button>
                </div>
              </form>
              <div class="mt-5 separator">or</div>
              <p class="flex items-center justify-between my-2">
                <a
                  href="/daftar"
                  class="block w-full px-5 py-2 text-xs text-center text-blue-700 focus:outline-none"
                  ><span class="text-gray-700">Don't Have Account?</span>
                  <br />Register</a
                >
                <a
                  href="/forget"
                  class="block w-full px-5 py-2 text-xs text-center text-yellow-700 focus:outline-none"
                  ><span class="text-gray-700">Forgot Password ?</span>
                  <br />Recover</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
<div class="flex justify-center max-w-screen-xl px-5 py-1 mx-auto items-bottom">
  <div
    class="w-full mt-4 text-sm font-light text-center text-gray-700 sm:py-2 sm:mt-0"
  >
    <div>
      <span class="ml-1 text-gray-700">© 2021 Mikhub — RakIT Labs</span>
    </div>
  </div>
</div>
